import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface DeleteEventGuest {
	uriParams: Api.Operations['deleteEventGuest']['parameters']['path']
	response: Api.Operations['deleteEventGuest']['responses']['204']
}

export const deleteEventGuest = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<DeleteEventGuest>(
		{
			method: 'delete',
			url: '/events/{eventId}/guests/{email}',
			...overideConfig,
		},
		axiosInstance,
	)
